<template>
    <div class="sales-page" v-if="pageSetup != null">
        <breadcrumbs></breadcrumbs>
        <div class="container">
            <div class="section-title section-title-sales">
                <h1>{{pageSetup.page_title}}</h1>
            </div>
            <salesFilter :title="pageSetup.page_title"></salesFilter>
            <salesItems></salesItems>
            <sharePostBottom :options="[{title: 'Поделиться данной страницей:', data_title: 'BAZIS-A | Жилые комплексы в продаже', data_link: 'https://sales.bazis.kz/sales', data_page: 'Жилые комплексы', data_page_key: 'sales'}]"></sharePostBottom>
            <BanerBottomVertical :options="[{page: 'sales'}]" class="sales-vertical-baner-bottom" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerBottomVertical>
        </div>
    </div>
</template>

<script>
    import BanerTopVertical from '@/components/baner-system/baner-top-vertical.vue'
    import BanerBottomVertical from '@/components/baner-system/baner-bottom-vertical.vue'
    import breadcrumbs from '@/components/breadcrumbs/breadcrumbs.vue'
    import {mapGetters} from 'vuex'
    import salesItems from '@/components/sales/sale-item.vue'
    import salesFilter from '@/components/sales/sales-filter.vue'
    import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import store from '@/store.js'
    export default {
        name: 'sales--page',
        components: {
            salesItems,
            salesFilter,
            sharePostBottom,
            breadcrumbs,
            BanerBottomVertical,
        },
        data () {
            return {
                titlePage: 'Жилые комплексы',
                crumb: 'Жилые комплексы',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadSalesPage',
            projectItems: 'loadProjectItems',
            titleSite: 'loadSiteTitle',
            banerSystem: 'loadBanerSystem',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.projectItems != null) {
                if (store.state.salesPage == null) {
                    store.dispatch('getSalesPageData').then((response) => {
                        if (response) {
                            next(vm => {
                                vm.$store.commit('setCustomCrumb', vm.crumb);
                                vm.$store.commit('removePageLoaderImg');
                                vm.$parent.$refs.topProgress.done()
                            });
                        }
                    })
                } else {
                    next(vm => {
                        vm.$store.commit('setCustomCrumb', vm.crumb);
                        vm.$store.commit('removePageLoaderImg');
                        vm.$parent.$refs.topProgress.done()
                    });
                }
            } else {
                store.dispatch('getSalesPageData');
                store.dispatch('getProjectsItems').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                            vm.$store.commit('setCustomCrumb', vm.crumb);
                            vm.$store.commit('removePageLoaderImg');
                            vm.$parent.$refs.topProgress.done()
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getSalesPageData');
            // this.$store.dispatch('getProjectsItems');
            document.body.dataset.page = 'sales';
        },
        created () {
            document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/realestate/sales.scss';
    @import '@/styles/respond/sales/respond-sales.scss';
</style>